import styled from 'styled-components';
import { GRUNDFOS_BLUE, BLUE1, BLUE3, ATTENTION_BLUE } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const AgentInfoPopover = styled.div<{ $top: number; $left: number }>`
  position: fixed;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  transform: translateY(-50%);
  background: white;
  border-radius: 12px;
  width: 300px;
  padding: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  animation: popoverFadeIn 0.2s ease;

  @keyframes popoverFadeIn {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  ${MEDIA.MOBILE} {
    position: fixed;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    transform: none;
    border-radius: 16px 16px 0 0;
    padding: 20px 16px;
    animation: popoverSlideUp 0.25s ease;

    @keyframes popoverSlideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
`;

export const AgentInfoPopover__Name = styled.h3`
  margin: 0 0 8px 0;
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.LARGE};
`;

export const AgentInfoPopover__Version = styled.span`
  display: inline-block;
  background: ${BLUE1};
  color: ${ATTENTION_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.SMALL};
  padding: 2px 10px;
  border-radius: 12px;
  margin-bottom: 12px;
`;

export const AgentInfoPopover__Description = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  line-height: 1.5;
  margin: 0 0 16px 0;
`;

export const AgentInfoPopover__Tabs = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 1px solid ${BLUE1};
  margin-bottom: 16px;
`;

export const AgentInfoPopover__Tab = styled.button<{ $active: boolean }>`
  flex: 1;
  background: none;
  border: none;
  border-bottom: 2px solid ${(props) => (props.$active ? ATTENTION_BLUE : 'transparent')};
  color: ${(props) => (props.$active ? ATTENTION_BLUE : BLUE3)};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.SMALL};
  padding: 8px 0;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: ${ATTENTION_BLUE};
  }
`;

export const AgentInfoPopover__TabContent = styled.div`
  min-height: 60px;
`;

export const AgentInfoPopover__PatchNotesTitle = styled.h4`
  margin: 0 0 8px 0;
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.SMALL};
`;

export const AgentInfoPopover__PatchNotes = styled.ul`
  margin: 0;
  padding: 0 0 0 16px;
  list-style-type: disc;
`;

export const AgentInfoPopover__PatchNote = styled.li`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  line-height: 1.6;
`;
